var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-with-buttons',{attrs:{"options":['A', 'K', 'Q', 'J', '10', '9', '8', '7', '6', '5', '4', '3', '2'].map(key => {
          return {value: key, text: key, class: ['scoreButton']};
        })},on:{"click":_vm.propagateClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }